<div (click)="onDaySelected()" class="w-full h-full flex justify-center items-center pl-[1rem] pr-[1rem]" [class.selected]="session.sessionNumber">
  <p><span *ngIf="session.sessionNumber">S{{session.sessionNumber | number:'2.0'}} </span>{{session.dateTime | date:'MMM dd yyyy'}}</p>
</div>
